<template>
  <div class="pageBottomTWShow">
    <div class="bottomMain">
      <div class="agencyAndTerms">
        <div class="leftImgAndAgency">
          <div class="leftImg">
            <img src="@/assets/imgs/tc/wild.png" class="showImgS" alt="">
            <img src="@/assets/imgs/tc/mamba.png" class="showImgS" alt="">
          </div>
          <div class="agencyShow">
            <div class="agentInfo">
              台灣遊戲代理：香港商曼巴互動娛樂股份有限公司台灣分公司
            </div>
            <div class="agentInfo">
              官方客服信箱：ccs＠mambahq.com
            </div>
            <div class="agentInfo">
              官方客服電話：+886 986-130-689（服務時間：10:00-19:00，週一至週日）
            </div>
          </div>
        </div>
        <div class="termsInfo">
          <div class="termsText">
            ※ 《MLB制勝時刻》依遊戲軟體分級管理辦法，分類為普遍級。本應用遊戲為免費使用，內另有提供購買虛擬遊戲幣、物品等付費服務。
            <span class="serviceText" @click="viewServiceOrPrivacy('service')">用戶協議</span>
            <span class="serviceText" @click="viewServiceOrPrivacy('privacy')">隱私權政策</span>
          </div>
          <div class="levelImg">
            <img src="@/assets/imgs/tc/ordinaryLevel.png" alt="">
          </div>
        </div>
      </div>
      <div class="extInfo">
        <div class="bookInfo">
          Major League Baseball的商標與著作權係由Major League Baseball官方所授權。詳情請至MLB.com查看。MLB Players,
          Inc.官方授權商品，其MLBPA的商標、著作權及其他智慧財產權均屬MLBPA所有和/或持有，未經MLBPA或MLB Players, Inc.
          的書面同意，不得擅自使用。詳情請至MLBPLAYERS.com查看“the Players Choice”相關內容。
          <br>
          ©2024 WILD CALY PTE. LTD. All rights reserved.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageBottomTaiwan',
  components: {},
  data() {
    return {}
  },
  props: {},
  mounted() {
  },
  methods: {
    viewServiceOrPrivacy(flag) {
      if (flag === 'service') {
        window.open('https://www.wildcaly.com/ToSTw.html', '_blank');
      } else {
        window.open('https://www.wildcaly.com/privacypolicyTw.html', '_blank');
      }
    }
  }
}
</script>

<style scoped lang="scss">
.pageBottomTWShow {
  padding: 20px 60px;
  background: #0C2659;
  display: flex;
  align-items: center;
  justify-content: center;

  .bottomMain {
    display: flex;
    flex-flow: column;
    .agencyAndTerms{
      display: flex;
      justify-content: space-between;
      //align-items: center;
      padding-bottom: 10px;
      border-bottom: 1px solid #D9D9D9;
      .leftImgAndAgency{
        flex: 2;
        display: flex;
        //align-items: center;
        .leftImg{
          display: flex;
          .showImgS{
            height: 88px;
            margin-right: 18px;
          }
        }
        @media screen and (max-width: 1920px){
          .agencyShow{
            color: #D9D9D9;
            font-size: 16px;
            text-align: left;
            padding-top: 10px;
            .agentInfo{
              margin-bottom: 2px;
            }
          }
        }
        @media screen and (min-width: 1921px) and (max-width: 2560px){
          .agencyShow{
            color: #D9D9D9;
            font-size: 20px;
            text-align: left;
            padding-top: 10px;
            .agentInfo{
              margin-bottom: 2px;
            }
          }
        }
        @media screen and (min-width: 2561px){
          .agencyShow{
            color: #D9D9D9;
            font-size: 30px;
            text-align: left;
            padding-top: 10px;
            .agentInfo{
              margin-bottom: 2px;
            }
          }
        }
      }
      .termsInfo{
        flex: 1;
        display: flex;
        //align-items: center;
        @media screen and (max-width: 1920px){
          .termsText{
            color: #D9D9D9;
            font-size: 16px;
            text-align: left;
            padding-top: 10px;
            .serviceText{
              margin-right: 10px;
              cursor: pointer;
              text-decoration: underline;
            }
          }
        }
        @media screen and (min-width: 1921px) and (max-width: 2560px){
          .termsText{
            color: #D9D9D9;
            font-size: 20px;
            text-align: left;
            padding-top: 10px;
            .serviceText{
              margin-right: 10px;
              cursor: pointer;
              text-decoration: underline;
            }
          }
        }
        @media screen and (min-width: 2561px){
          .termsText{
            color: #D9D9D9;
            font-size: 30px;
            text-align: left;
            padding-top: 10px;
            .serviceText{
              margin-right: 10px;
              cursor: pointer;
              text-decoration: underline;
            }
          }
        }
        .levelImg{
          margin-left: 20px;
          height: 88px;
          img{
            height: 100%;
          }
        }
      }
    }
    @media screen and (max-width: 1920px){
      .extInfo{
        margin-top: 10px;
        color: #D9D9D9;
        font-size: 16px;
        line-height: 1.5;
        .bookInfo{
          text-align: left;
        }
      }
    }
    @media screen and (min-width: 1921px) and (max-width: 2560px){
      .extInfo{
        margin-top: 10px;
        color: #D9D9D9;
        font-size: 20px;
        line-height: 1.5;
        .bookInfo{
          text-align: left;
        }
      }
    }
    @media screen and (min-width: 2561px){
      .extInfo{
        margin-top: 10px;
        color: #D9D9D9;
        font-size: 30px;
        line-height: 1.5;
        .bookInfo{
          text-align: left;
        }
      }
    }
  }
}
</style>
